export function isSubschemaConfig(value) {
    return Boolean(value === null || value === void 0 ? void 0 : value.schema);
}
export function cloneSubschemaConfig(subschemaConfig) {
    const newSubschemaConfig = {
        ...subschemaConfig,
        transforms: subschemaConfig.transforms != null ? [...subschemaConfig.transforms] : undefined,
    };
    if (newSubschemaConfig.merge != null) {
        newSubschemaConfig.merge = { ...subschemaConfig.merge };
        Object.keys(newSubschemaConfig.merge).forEach(typeName => {
            newSubschemaConfig.merge[typeName] = { ...subschemaConfig.merge[typeName] };
            const fields = newSubschemaConfig.merge[typeName].fields;
            if (fields != null) {
                Object.keys(fields).forEach(fieldName => {
                    fields[fieldName] = { ...fields[fieldName] };
                });
            }
        });
    }
    return newSubschemaConfig;
}
//# sourceMappingURL=subschemaConfig.js.map